'use client';

import Image from "next/image";
import Link from "next/link";
import styles from './index.module.scss';
import MainButton from "@/app/_components/Shared/MainButton";
import DashboardChart from '@/app/images/DashboardChart.png';

export default function HeroLandingSection() {
  return (
    <section className={styles.container}>
      <div className="container-wrapper">
        <div className={styles.grid}>
          {/* Left Content */}
          <div className={styles.content}>
            <div className={styles.badge}>
              PRO Services in the UAE
            </div>

            <h1 className={styles.title}>
              Take the admin workload off your plate with our expert <span className={styles.highlight}>PRO services</span> team
            </h1>

            <p className={styles.description}>
              At Ninjaz, we handle your licenses, visas, and all essential government procedures with speed and accuracy. From routine renewals to complex documentation, our PRO specialists ensure everything runs smoothly—so you can stay focused on building and scaling your business across the UAE.
            </p>

            <div className={styles.buttons}>
              <Link href="/pro-services-request">
                <MainButton color="info">
                  Get Started
                  <svg className={styles.buttonIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </MainButton>
              </Link>
              <Link href="/about-us">
                <MainButton color="white">
                  Learn More
                </MainButton>
              </Link>
            </div>

            {/* Stats */}
            <div className={styles.stats}>
              <div className={styles.stat}>
                <div className={styles.statValue}>500+</div>
                <div className={styles.statLabel}>Active Clients</div>
              </div>
              <div className={styles.stat}>
                <div className={styles.statValue}>24/7</div>
                <div className={styles.statLabel}>Support</div>
              </div>
              <div className={styles.stat}>
                <div className={styles.statValue}>99%</div>
                <div className={styles.statLabel}>Satisfaction</div>
              </div>
            </div>
          </div>

          {/* Right Dashboard Mockup */}
          <div className={styles.imageWrapper}>
            <Image
              src={DashboardChart}
              alt="Dashboard Analytics"
              width={600}
              height={500}
              className={styles.image}
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
}
